<script lang="ts">
	import { PUBLIC_SITE_URL } from "$env/static/public";

	export let data;
	$: posts = data.posts.sort((a, b) => a.name.localeCompare(b.name));
	$: types = [...new Set(posts.map((post) => post.type))];
	function getName(type: string) {
		switch (type) {
			case "integration":
				return "Integrations";
			case "automation":
				return "Automation";
			case "feature":
				return "Features";
			default:
				return type;
		}
	}
</script>

<svelte:head>
	<title>Addons - Formcrafts</title>
	<link rel="canonical" href="{PUBLIC_SITE_URL}/addons" />
</svelte:head>

<div class="w-full flex flex-col gap-8 mx-auto">
	<header class="mb-8">
		<h1 class="font-bold text-3xl md:text-4xl text-balance mb-2">
			Addons and integrations
		</h1>
		<div class="text-gray-500">
			Extend Formcrafts with addons and integrations to automate your workflow.
		</div>
	</header>
	<main class="flex flex-col gap-14">
		{#each types as type}
			<section>
				<h2 class="font-bold text-2xl md:text-3xl mb-4 text-gray-500">
					{getName(type)}
				</h2>
				<ul
					class="flex flex-col md:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 list-none items-stretch">
					{#each posts.filter((x) => x.type === type) as post}
						<li class="p-0 m-0">
							<a
								href="/addons/{post.slug}"
								class="no-underline p-6 flex flex-col bg-gray-150 flex-1 rounded-lg hover:focus-ring-theme-solid-inset">
								<div class="flex flex-col gap-1">
									<div class="flex flex-row gap-2 items-center">
										<img
											width="512"
											height="512"
											src="/images/addons/{post.slug}.png"
											class="size-5 rounded-sm"
											alt="{post.name} logo" />
										<h3 class="text-base font-medium">
											{post.name}
										</h3>
									</div>
									<div class="text-sm h-10 mt-2 line-clamp-2">
										{post.description}
									</div>
								</div>
							</a>
						</li>
					{/each}
				</ul>
			</section>
		{/each}
	</main>
</div>
